import {erNil} from "./nilsjekk";
import {erStreng} from "felles-ng2/støttefunksjoner/strenger";

export function uriEnkodet(verdi: string): string {
    return encodeURIComponent(verdi);
}

export function uriDekodet(verdi: string): string {
    if (erNil(verdi)) return verdi;
    return decodeURIComponent(verdi);
}

/** Sann dersom angitt verdi er en https-url. */
export function erHttpsUrl(verdi: any): boolean {
    //må være en streng
    if (!erStreng(verdi)) return false;

    let trimmetVerdi = verdi.trim();

    //kan ikke inneholde blanke tegn
    if (/\s/.test(trimmetVerdi)) return false;

    //må starte på https://
    if (!trimmetVerdi.toLowerCase().startsWith('https://')) return false

    try {
        //må kunne parses av new URL
        const url = new URL(trimmetVerdi);
        return true

    } catch (e) {
        return false;
    }
}
